import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import Element from './Element'
import { getCoreColor } from './element-helpers'
import {getItemBy} from '../../helpers'

class VGroove extends Component {

    getShape( width, height, id, shape ) {

        let scale = width / shape.width,
            path = (
                <path
                    id={`${id}-path`}
                    d={shape.d}
                    transform={`scale(${width / shape.width} ${height /
                        shape.height})`}
                />
            );

        return {path, scale}
    }

    render() {

        const { id, activeElement, shape, width, height, depth, projectMats } = this.props
        const isActive = activeElement === id
        const coreColor = getCoreColor( projectMats, depth )
        const shapeEl = this.getShape( width, height, id, shape )

        return  <Element {...this.props} isActive={isActive}>
    				<defs>
    					{shapeEl.path}
    				</defs>
                    <use
                        href={`#${id}-path`}
                        fill="none"
                        stroke="rgba(0,0,0,0.1)"
                        strokeWidth={4 / shapeEl.scale}
                        strokeDasharray="none"
                        />
                    <use
                        href={`#${id}-path`}
                        fill="none"
                        stroke={coreColor}
                        strokeWidth={2 / shapeEl.scale}
                        strokeDasharray="none"
                        />
    			</Element>

    }
}

VGroove.propTypes = {

    id: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]).isRequired,
    shape: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]).isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    editable: PropTypes.bool,
    parent: PropTypes.string,
    activeElement: PropTypes.string,
    projectMats: PropTypes.array.isRequired,
}

function mapStateToProps(state, ownProps) {
    const parentObject = getItemBy('id', ownProps.parent, state.project.present.elements)
    const activeElementObject = getItemBy('id', state.tools.activeElement, state.project.present.elements)
    return {
        activeElement: state.tools.activeElement,
        parentObject,
        activeElementObject,
        lockedMode: state.app.lockedMode
    }
}

export default connect(mapStateToProps)(VGroove)
